import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { columnArguments } from '~/modules/common/hooks/project';
import { projectListItemFragment } from '~/modules/common/fragments';

export const GET_PROJECTS_QUERY = gql`
  query getProjects(
    $page: Int!
    $pageSize: Int!
    $projectFilter: ProjectFilter2
    $sort: ProjectSort
    $isManaged: Boolean
    $tagIds: [String!],
    ${columnArguments}
  ) {
    projects(
      page: $page
      pagesize: $pageSize
      projectFilter: $projectFilter
      sort: $sort
      isManaged: $isManaged
      tagIds: $tagIds
    ) {
      ...ProjectListItem,
    }
  }
  ${projectListItemFragment}
`;

export const useGetProjectsQuery = (options, query = GET_PROJECTS_QUERY) => {
  const { variables = {} } = options;

  const queryOptions = {
    variables
  };

  return useQuery(query, { ...options, ...queryOptions });
};
